import { openModal } from "../../../ui/containers/Modal";
import { createElement } from "../../../ui/ui";
import { DeathModal } from "../../ui/endConds/death";
import { Actor } from "../Actor";
import wordTriggers from "./wordTriggers";
import EntityManager from "../../EntityManager";
import { VictoryModal } from "../../ui/endConds/victory";
import { VH, VW } from "../../../tiles";
import { gameData } from "../../GameManager";

export default {
  standardHunger: (actor: Actor) => {
    actor.health.change(-1);
    actor.hunger.fill();
  },
  standardHealth: (actor: Actor) => {
    EntityManager.removeActorAndPieces(actor);
  },
  playerHealth: (actor: Actor) => {
    actor.end();
    if (!gameData.victory) {
      openModal(createElement(DeathModal, { x: 0, y: 15, w: VW, h: 6 }), {
        hideBorder: true,
      });
    }
  },
  victoryHealth: (actor: Actor) => {
    gameData.victory = true;
    EntityManager.removeActorAndPieces(actor);
    openModal(createElement(VictoryModal, { x: 0, y: 15, w: VW, h: 6 }), {
      hideBorder: true,
    });
  },
  ...wordTriggers,
} as Record<string, (actor: Actor, options: any, params: any) => void>;

//61-29=
